<div class="section-container" [attr.data-test-section]="section?.id" 
[ngClass]="{'active': section?.isActive, 'progress-border': section?.isActive, 'disabled': section?.isDisabled,'error-border': section?.isErrors, 'success-border': section?.isCompleted}">
    <div matRipple class="list-item" (click)="handleSelectSection(section)">
        <div class="list-item-title">{{ title }}</div>
    </div>
</div>